import {
  ChangeDetectorRef,
  Component,
  ComponentFactoryResolver,
  OnInit,
  ViewChild,
  ViewContainerRef
} from '@angular/core';
import { BasePlugin } from '../../base-plugin.component';
import { Inspection } from '../../../shared/models/index';
import { DynamicDirective } from './dynamic.directive';
import { Subject } from 'rxjs';

@Component({
    templateUrl: './view.component.html',
    standalone: false
})
export class BaseInstallationPluginComponent extends BasePlugin implements OnInit {
  inspection: Inspection;
  pluginName: string;
  childPlugin;
  pluginComponent;
  editRoute$: Subject<any> = new Subject<any>();

  @ViewChild(DynamicDirective) dynamicPlugin!: DynamicDirective;

  constructor(
    public viewContainerRef: ViewContainerRef,
    private componentFactoryResolver: ComponentFactoryResolver,
    private cdRef: ChangeDetectorRef
  ) {
    super();
  }

  config(
    plugin: any,
    inspection: Inspection,
    messages: string[],
    showBreadcrumbs: boolean,
    showValidations: boolean,
    showContent: boolean
  ): void {
    super.config(plugin, inspection, messages, showBreadcrumbs, showValidations, showContent);
    this.cdRef.detectChanges();
  }

  ngOnInit(): void {
    this.loadComponent();
    this.initEditRoute();
    this.cdRef.detectChanges();
  }

  loadComponent() {
    if (!this.pluginComponent) return;
    if (!this.showContent) {
      this.childPlugin = new this.pluginComponent();
      return;
    }
    const componentFactory = this.componentFactoryResolver.resolveComponentFactory(this.pluginComponent);
    const viewContainerRef = this.dynamicPlugin.viewContainerRef;
    const cmp = viewContainerRef.createComponent(componentFactory);
    this.childPlugin = <any>cmp.instance;
    if (this.childPlugin.setConfig && typeof this.childPlugin.setConfig === 'function') {
      this.childPlugin.setConfig(this.plugin.config, this.inspection, this.plugin);
    }
  }

  private initEditRoute() {
    if (!this.childPlugin?.editRoute) return;
    let url = this.plugin.pointId
      ? [
          this.inspection.isTemplate() ? this.templatesRoute : this.inspectionsRoute,
          this.inspection.id,
          'points',
          this.plugin.pointId,
          'plugins',
          this.plugin.id,
          ...this.childPlugin.editRoute
        ]
      : [
          this.inspection.isTemplate() ? this.templatesRoute : this.inspectionsRoute,
          this.inspection.id,
          'plugins',
          this.plugin.id,
          ...this.childPlugin.editRoute
        ];
    this.editRoute$.next(url);
  }
}
